import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import AdminMetrics from './AdminMetrics';
import DoctorMetrics from './DoctorMetrics';

interface RoleMetricsProps {
  totalPatients: number;
}

const RoleMetrics: React.FC<RoleMetricsProps> = ({ totalPatients }) => {
  const { user } = useAuth();

  if (user?.role === 'admin') return <AdminMetrics totalPatients={totalPatients} />;
  if (user?.role === 'doctor') return <DoctorMetrics totalPatients={totalPatients} />;
  return null;
};

export default RoleMetrics;
